export interface EtiquetaMateriaPrimaFornecedor1 {
  CA2CODLOJA: string;
  CB1COD: string;
  CLOTEFORNECEDOR: string;
  NQUANTIDADE: number;
  DRECEBIMENTO: Date;

}
export const defaultEtiquetaMateriaPrimaFornecedor1 = (): EtiquetaMateriaPrimaFornecedor1 => {
  return{
    CA2CODLOJA: '',
    CB1COD: '',
    CLOTEFORNECEDOR: '',
    NQUANTIDADE: 0,
    DRECEBIMENTO: new Date(),
  };
};
